import { COLORS } from 'constants';

export const getInventoryItemStateColor = (value) => {
    switch (value) {
        case "Good":
            return COLORS.GREEN;
        case "Average":
            return COLORS.ORANGE;
        case "Bad":
            return COLORS.RED;
        case "Critical":
            return COLORS.DARK_RED;
        case "Unknown":
            return COLORS.DARK_GRAY;
        default:
            return COLORS.GRAY;
    }
}